// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { PRICE_TYPE_SELECT_CLASS_NAME } from "../../../../core/constants/className";
import { map } from "../../../../../../io/hyperify/core/functions/map";
import { parseProductPriceType, ProductPriceType } from "../../../../../../io/hyperify/core/store/types/product/ProductPriceType";
import { getSelectPriceTypeTextForPriceType } from "../../../../../../io/hyperify/core/store/constants/storeTranslation";
import { ChangeEvent, useCallback } from "react";
import { LogService } from "../../../../../../io/hyperify/core/LogService";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./PriceTypeSelect.scss";

const LOG = LogService.createLogger('PriceTypeSelect');

export interface PriceTypeSelectProps {
    readonly t          : TranslationFunction;
    readonly className ?: string;
    readonly value      : ProductPriceType;
    readonly setValue  ?: (value: ProductPriceType) => void;
    readonly options    : readonly ProductPriceType[];
    readonly dark      ?: boolean;
}

export function PriceTypeSelect (props: PriceTypeSelectProps) {

    const className = props?.className;
    const dark : boolean = props?.dark ?? false;
    const t = props?.t;
    const priceType = props?.value;
    const priceTypeOptions = props?.options;
    const setPriceType = props?.setValue;

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLSelectElement>) => {
            const value = parseProductPriceType(e?.target?.value);
            if (value) {
                if ( setPriceType ) {
                    setPriceType(value);
                } else {
                    LOG.debug(`No setPriceType callback defined`);
                }
            } else {
                LOG.debug(`No value to set`);
            }
        },
        [
            setPriceType
        ]
    );

    return (
        <div className={
            PRICE_TYPE_SELECT_CLASS_NAME
            + (className? ` ${className}` : '')
            + (dark?' '+PRICE_TYPE_SELECT_CLASS_NAME+'-dark': '')
        }>
            {priceTypeOptions?.length >= 2 ? (
                <select
                    className={`${PRICE_TYPE_SELECT_CLASS_NAME}-select`}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => handleChange(e)}
                    value={priceType}
                >{map(priceTypeOptions, (item : ProductPriceType, key: number) => (
                    <option
                        key={key}
                        value={item}
                        className={`${PRICE_TYPE_SELECT_CLASS_NAME}-select-option`}
                    >{t(getSelectPriceTypeTextForPriceType(item))}</option>
                ))}</select>
            ) : null}
        </div>
    );
}
